import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  NavLink,
} from "react-router-dom";
import { FrontPageHeader } from "../../pages/FrontPage/FrontPage";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Button, Grid } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  nav: {
    margin: "40px 0",
    textAlign: "center",
  },
  link: {
    margin: "0 15px",
    padding: "12px 30px",
    fontSize: "16px",
    fontWeight: 600,
    textTransform: "uppercase",
    backgroundColor: "#000",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "30px",
    display: "inline-block",
    "&:hover": {
      backgroundColor: "#333",
    },
    "&.active": {
      backgroundColor: "#555",
      boxShadow: "0 0 15px rgba(0,0,0,0.3)",
    },
  },
  iframeContainer: {
    marginTop: "20px",
  },
}));

const GeneralNordic = () => (
  <>
    <iframe
      src="https://intact-angler.metabaseapp.com/public/dashboard/264772e6-a917-45d7-ac26-5535dce659da"
      title="nordic-dashboard"
      frameBorder="0"
      allowFullScreen
      style={{ width: "100%", height: "100vh", border: "none" }}
    />
  </>
);
const Denmark = () => (
  <>
    <iframe
      src="https://intact-angler.metabaseapp.com/public/dashboard/611a72e4-2035-4b39-a8fa-b39437bfadd7"
      title="Denmark Dashboard"
      frameBorder="0"
      allowFullScreen
      style={{ width: "100%", height: "100vh", border: "none" }}
    />
  </>
);

const Finland = () => (
  <iframe
    src="https://intact-angler.metabaseapp.com/public/dashboard/50e0d7e4-62fa-4d42-a3d6-5366e191d2ab"
    title="Finland Dashboard"
    frameBorder="0"
    allowFullScreen
    style={{ width: "100%", height: "100vh", border: "none" }}
  />
);

const Norway = () => (
  <iframe
    src="https://intact-angler.metabaseapp.com/public/dashboard/cafd22c0-2c90-4532-aea7-f4c8238de117"
    title="Norway Dashboard"
    frameBorder="0"
    allowFullScreen
    style={{ width: "100%", height: "100vh", border: "none" }}
  />
);

const Sweden = () => (
  <iframe
    src="https://intact-angler.metabaseapp.com/public/dashboard/513f03b4-434d-4fa5-9ea8-b763b942aafc"
    title="Sweden Dashboard"
    frameBorder="0"
    allowFullScreen
    style={{ width: "100%", height: "100vh", border: "none" }}
  />
);

const DashboardHome = () => {
  const classes = useStyles();
  const openDashboard = (country: string) => {
    window.open(`/nordic/${country}`, "_blank");
  };

  return (
    <Container maxWidth="md">
      <div style={{ textAlign: "center", padding: "60px 20px" }}>
        <h1>Nordic Analytics</h1>

        <div className={classes.nav}>
          <NavLink
            to="nordic/denmark"
            className={classes.link}
            onClick={(e) => {
              e.preventDefault();
              openDashboard("denmark");
            }}
          >
            DENMARK
          </NavLink>
          <NavLink
            to="nordic/finland"
            className={classes.link}
            onClick={(e) => {
              e.preventDefault();
              openDashboard("finland");
            }}
          >
            FINLAND
          </NavLink>
          <NavLink
            to="nordic/sweden"
            className={classes.link}
            onClick={(e) => {
              e.preventDefault();
              openDashboard("sweden");
            }}
          >
            SWEDEN
          </NavLink>
          <NavLink
            to="nordic/norway"
            className={classes.link}
            onClick={(e) => {
              e.preventDefault();
              openDashboard("norway");
            }}
          >
            NORWAY
          </NavLink>
        </div>
      </div>
    </Container>
  );
};

const NordicDashboard: React.FC = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/nordic">
          <FrontPageHeader />
          <GeneralNordic />
        </Route>
        <Route path="/nordic/denmark">
          <FrontPageHeader />
          <Denmark />
        </Route>
        <Route path="/nordic/finland">
          <FrontPageHeader />
          <Finland />
        </Route>

        <Route path="/nordic/norway">
          <FrontPageHeader />
          <Norway />
        </Route>
        <Route path="/nordic/sweden">
          <FrontPageHeader />
          <Sweden />
        </Route>
      </Switch>
    </Router>
  );
};

export default NordicDashboard;
